const languageTypes = {
    ANY: 'xx',
    AR: 'ar',
    DE: 'de',
    EN: 'en',
    ES: 'es',
    FR: 'fr',
    IT: 'it',
    JA: 'ja',
    NB: 'nb',
    NL: 'nl',
    PL: 'pl',
    PT: 'pt',
    SV: 'sv',
    ZH_CN: 'zh-cn',
    ZH_TW: 'zh-tw',
};

export default languageTypes;
